import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.location_id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'tabs/add',
      tab: {
        id: 'Settings',
        type: 'Settings',
        name: 'Settings',
        viewPath: '/App/Account/Content/Settings/Content/CalendarSettings',
        coreMessage: {},
        selected: {
          tab: 'calendar-settings',
          mobile_numbers_outbound: [],
          nps_locations: [],
          marketing_analytics_locations: [],
          marketing_analytics_campaigns: [],
          marketing_analytics_range: { date_start: null, date_end: null },
          refetch: false,
          document_templates: {
            location_id: null,
            document_template: null,
            selected: [],
          },
          calendar_settings: {
            location_id,
          },
        },
      },
    })
  }
}
